document.addEventListener('DOMContentLoaded', function () {

  /* =======================
     THUMBS (превью)
  ======================= */

  const thumbsContainer = document.querySelector('.gallery-thumbs');
  if (!thumbsContainer) return;

  const thumbsSwiper = new Swiper('.gallery-thumbs', {
    spaceBetween: 8,
    slidesPerView: 4,
    direction: 'vertical',
    freeMode: true,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    loop: false,
    navigation: {
      nextEl: '.thumbs-next',
      prevEl: '.thumbs-prev'
    },
    breakpoints: {
      0: {
        slidesPerView: 'auto',
        direction: 'horizontal'
      },
      992: {
        slidesPerView: 4,
        direction: 'vertical'
      }
    }
  });

  /* =======================
     MAIN SLIDER
  ======================= */

  const mainSwiper = new Swiper('.gallery-main', {
    spaceBetween: 10,
    loop: true,
    thumbs: {
      swiper: thumbsSwiper
    }
  });

  /* =======================
     MODAL SLIDER
  ======================= */

  const modalSwiper = new Swiper('.gallery-modal-swiper', {
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  });

  /* =======================
     MODAL LOGIC
  ======================= */

  const modal = document.getElementById('galleryModal');
  const modalClose = modal.querySelector('.gallery-modal-close');
  const modalContent = modal.querySelector('.gallery-modal-content');

  // ▶️ Открытие модалки
  mainSwiper.on('click', () => {
    if (typeof mainSwiper.clickedIndex === 'undefined') return;

    modal.style.display = 'flex';
    modalSwiper.slideToLoop(mainSwiper.realIndex, 0);
  });

  // ▶️ Управление видео (КЛЮЧЕВОЙ ФИКС)
  modalSwiper.on('slideChange', () => {

    // удаляем iframe со всех слайдов
    modalSwiper.slides.forEach(slide => {
      const iframe = slide.querySelector('iframe');
      if (iframe) iframe.remove();
    });

    const activeSlide = modalSwiper.slides[modalSwiper.activeIndex];
    const videoId = activeSlide.dataset.video;

    if (videoId) {
      activeSlide.innerHTML = `
        <iframe
          src="https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1"
          style="border:none;width:100%;min-height:80vh;"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen>
        </iframe>
      `;
    }
  });

  // ❌ Закрытие модалки
  function closeModal() {
    modal.style.display = 'none';

    modalSwiper.slides.forEach(slide => {
      const iframe = slide.querySelector('iframe');
      if (iframe) iframe.remove();
    });
  }

  modalClose.addEventListener('click', closeModal);

  modal.addEventListener('click', e => {
    if (!modalContent.contains(e.target)) closeModal();
  });

});
